export type JsonValue = string | number | boolean | null | undefined

export interface FlagEntry {
  enabled: boolean
  value: JsonValue
}

export type FlagValues = Record<string, FlagEntry>

export const DEFAULT_FLAG_ENTRY: FlagEntry = { enabled: false, value: undefined } as const

export interface Adapter {
  initialize?(): Promise<void>
  decide(params: { key: string }): Promise<FlagEntry>
  resolveAll(): Promise<FlagValues>
}

export interface FlagDeclaration<T extends JsonValue = boolean> {
  key: string
  defaultValue: T
  description?: string
  adapter?: Adapter
  decide?: (params: { key: string; defaultValue?: T }) => Promise<T> | T
}
